import { Enum, EnumType } from 'ts-jenum';

@Enum<RouteTableTypeEnum>('value')
export class RouteTableTypeEnum extends EnumType<RouteTableTypeEnum>() {
   static readonly CALLS = new RouteTableTypeEnum(1, 'Calls');
   static readonly MESSAGES = new RouteTableTypeEnum(2, 'Messages');

   private constructor(public value: number, public name: string) {
      super();
   }
}
